import CardIntegrations from '@/models/Settings/Institutions/Integrations/CardIntegrations';

export default (cardIntegration: CardIntegrations) => {
    let returnVal = "Undefined";
    switch (cardIntegration) {
        case CardIntegrations.Accomplish:
            returnVal = "Accomplish"
            break;
        case CardIntegrations.GPS:
            returnVal = "GPS (Thredd)"
            break;
        case CardIntegrations.Marqeta:
            returnVal = "Marqeta"
            break;
    }
    return returnVal;
}